module.exports = __webpack_public_path__ + "80288a48c4c782c4e4a79d4fbb4fbf6c.jpg";